<script setup lang="ts">
interface TagProps {
    label: string;
    icon?: string;
    closable?: boolean;
}

defineProps<TagProps>();

const emit = defineEmits(["click"]);
const onClick = () => {
    emit("click");
};
</script>
<template>
    <button @click="() => onClick()" :class="['badge', { closable }]">
        <i v-if="icon" :class="`ti ti-${icon}`"></i>
        <div class="text">{{ label }}</div>
        <i v-if="closable" class="ti ti-x"></i>
    </button>
</template>
<style scoped lang="scss">
.badge {
    display: flex;
    gap: 2px;
    padding: 2px 6px;
    border-radius: 6px;
    border: 1px solid $stroke-soft-200;
    color: $text-main-900;
    font-size: 12px;
    line-height: 18px;
    background: none;
    cursor: default;
    &.closable {
        cursor: pointer;
    }
    .ti {
        display: block;
        margin: auto 0;
        color: $neutral-500;
        font-size: 14px;
    }
}
</style>
